import { StringUnionKeyAsValue } from '~commonInfra/utils/TypescriptHelpers';
import { ExploreContentApi_ContentType } from '~src/spacesPlatform/models/IContent';
import { IExplorableItemTypeInfo } from '~src/spacesPlatform/models/resourceInfoParts';


/**
 * These are the item types that can be browsed in an Explorer.
 * Includes the "primary" content types (from the exploreContent API) and also non-content
 * entities that can be browsed (e.g. subscriptions, refresh extracts).
 */
export type ExplorableItemType = ExploreContentApi_ContentType
    | 'accelerationTask'
    | 'backgroundJob'
    | 'collection'
    | 'connectedApplication'
    | 'connectedWorkbook'
    | 'connection'
    | 'customView'
    | 'dataalert'
    | 'extractTask'
    | 'flowOutputStepRun'
    | 'group'
    | 'recommendedView'
    | 'remoteRefreshSchedule'
    | 'resourceGovernanceSetting'
    | 'runFlowTask'
    | 'schedule'
    | 'searchuser' // Currently used to display user results in search
    | 'serveruser'
    | 'userIdentityConflict'
    | 'site'
    | 'siteuser'
    | 'subscription'
    | 'performance'
    | 'runFlowTask'
  ;

export const ExplorableItemTypeValue: StringUnionKeyAsValue<ExplorableItemType> = {
  accelerationTask: 'accelerationTask',
  backgroundJob: 'backgroundJob',
  collection: 'collection',
  connectedApplication: 'connectedApplication',
  connectedWorkbook: 'connectedWorkbook',
  connection: 'connection',
  customView: 'customView',
  dataalert: 'dataalert',
  database: 'database',
  dataconnection: 'dataconnection',
  dataRole: 'dataRole',
  datasource: 'datasource',
  extractTask: 'extractTask',
  flow: 'flow',
  flowOutputStepRun: 'flowOutputStepRun',
  group: 'group',
  lens: 'lens',
  metric: 'metric',
  project: 'project',
  predictiveModel: 'predictiveModel',
  virtualConnection: 'virtualConnection',
  virtualConnectionTable: 'virtualConnectionTable',
  virtualConnectionColumn: 'virtualConnectionColumn',
  recommendedView: 'recommendedView',
  remoteRefreshSchedule: 'remoteRefreshSchedule',
  resourceGovernanceSetting: 'resourceGovernanceSetting',
  runFlowTask: 'runFlowTask',
  schedule: 'schedule',
  searchuser: 'searchuser',
  serveruser: 'serveruser',
  userIdentityConflict: 'userIdentityConflict',
  site: 'site',
  siteuser: 'siteuser',
  subscription: 'subscription',
  performance: 'performance',
  table: 'table',
  view: 'view',
  workbook: 'workbook',
};

/**
 * These are the entity types that have their own landing pages ("space page").
 * These content types and explorable items, so their names should match where possible.
 */
export type SpaceInfoItemType = 'project' | 'schedule' | 'workbook' | 'view' | 'datasource' | 'flow'
  | 'dataRole' | 'lens' | 'group' | 'siteuser'| 'serveruser' | 'metric' | 'collection' | 'virtualConnection'
  | 'virtualConnectionTable' | 'resourceGovernanceSetting' | 'connectedApplication' | 'predictiveModel'
  | 'database' | 'table';

export const SpaceInfoItemTypeValue: StringUnionKeyAsValue<SpaceInfoItemType> = {
  project: 'project',
  workbook: 'workbook',
  view: 'view',
  datasource: 'datasource',
  flow: 'flow',
  dataRole: 'dataRole',
  lens: 'lens',
  group: 'group',
  siteuser: 'siteuser',
  serveruser: 'serveruser',
  schedule: 'schedule',
  metric: 'metric',
  collection: 'collection',
  virtualConnection: 'virtualConnection',
  virtualConnectionTable: 'virtualConnectionTable',
  resourceGovernanceSetting: 'resourceGovernanceSetting',
  connectedApplication: 'connectedApplication',
  predictiveModel: 'predictiveModel',
  database: 'database',
  table : 'table',
};

export function isSpaceInfoItemType(itemType: string): itemType is SpaceInfoItemType {
  return SpaceInfoItemTypeValue.hasOwnProperty(itemType);
}

export function isRecommendationType(itemType: ExplorableItemType): itemType is ExplorableItemType {
  const recommendationTypes = ['recommendedView'];
  return itemType && recommendationTypes.includes(itemType);
}

export function mapRecTypeToBaseType(itemType: string): SpaceInfoItemType{
  if (itemType === 'recommendedView') {
    return 'view';
  }
}

export function getKeyForExplorableItem(item: IExplorableItemTypeInfo): string {
  return `${item.contentType}_${item.id}`;
}
